import { AdminCartsQueryRequest, AdminCartsQueryResponse, AdminCartUpdateRequest } from '@/venit/services/model/techpubs-cms';
import axios, { AxiosResponse } from 'axios';

export interface CortonaPartLinkResult {
  resourceId: string;
  viewBookmark: string | null;
  partRefId: string;
}

export default class AdminCartsService {
  public query(listRequest: AdminCartsQueryRequest): Promise<AxiosResponse<AdminCartsQueryResponse>> {
    return axios.post<AdminCartsQueryResponse>(`/api/admin/carts/query`, listRequest);
  }

  public update(updateRequest: AdminCartUpdateRequest): Promise<AxiosResponse<void>> {
    return axios.post(`/api/admin/carts/update`, updateRequest);
  }

  public delete(cartId: string): Promise<AxiosResponse<void>> {
    return axios.delete(`/api/admin/carts/${cartId}`);
  }

  public lookupCortonaPart(partName: string): Promise<AxiosResponse<CortonaPartLinkResult>> {
    return axios.get<CortonaPartLinkResult>(`/api/admin/carts/part-link`, { params: { partName } });
  }
}